// extracted by mini-css-extract-plugin
export default {"content-parent":"overlay_content-parent__6e5tv"};